"use strict";

var React           = require("react");
var Router          = require("react-router");
var Link = Router.Link;
var Header = require("./Header.react");
var Footer = require("./Footer.react");
var Navbar = require("./FrontpageNavbar.react");
var Information = require("./Information.react");
var browser         = require("detect-browser");

var Frontpage = React.createClass({
    scrollTo: function(element, to, duration) {
        Math.easeInOutQuad = function (t, b, c, d) {
            t /= d/2;
            if (t < 1) return c/2*t*t + b;
            t--;
            return -c/2 * (t*(t-2) - 1) + b;
        };

        var start = element.scrollTop,
            change = to - start,
            currentTime = 0,
            increment = 20;

        var animateScroll = function(){
            currentTime += increment;
            var val = Math.easeInOutQuad(currentTime, start, change, duration);
            element.scrollTop = val;
            if(currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };

        animateScroll();
    },
    checkScroll: function(type){
        var itOffset = document.getElementsByClassName("information")[0].offsetTop;
        var element = document.body;
        if (browser.name === "firefox") {
            element = document.documentElement;
        }
        this.scrollTo(element, itOffset, 1000);
    },
    render: function () {
        return (
            <div className="Frontpage">
                <Navbar />
                <Header checkScroll={this.checkScroll} />
                <Information />
                <Footer/>
            </div>
        );
    }
});

module.exports = Frontpage;



// WEBPACK FOOTER //
// ./app/scripts/ui/Frontpage/Frontpage.react.js